import React, { useCallback, useMemo } from 'react';
import { } from 'reactstrap'; // This might be better as just removing the line if no imports are lefte but other files might need it. Actually, reactstrap is purely used for UI. If nothing used, remove line.
import PropTypes from 'prop-types';

/**
 * Teclado Virtual estilo tela touch
 * Orientado ao uso em totens de atendimento
 */
const VirtualKeyboard = ({ onKeyPress, onDelete, onSpace, onClear }) => {
    // Teclado QWERTY simplificado otimizado para busca de nomes
    const rows = useMemo(() => [
        ['Q','W','E','R','T','Y','U','I','O','P'],
        ['A','S','D','F','G','H','J','K','L'],
        ['Z','X','C','V','B','N','M']
    ], []);

    const handleKey = useCallback((key) => {
        onKeyPress?.(key);
    }, [onKeyPress]);

    return (
        <div className="w-100">
            {rows.map((row, i) => (
                <div key={i} className="d-flex justify-content-center mb-2" style={{ gap: "4px" }}>
                    
                    {/* Elemento fantasma para equilibrar a 3ª linha na esquerda igual ao iPhone */}
                    {i === 2 && (
                        <div style={{ flex: "1 1 0px", minWidth: "0", maxWidth: "60px" }}></div>
                    )}

                    {row.map(key => (
                        <button
                            key={key}
                            className="btn shadow-sm border-0 d-flex align-items-center justify-content-center fw-bold text-dark kiosk-key"
                            style={{ 
                                flex: "1 1 0px", 
                                minWidth: "0", 
                                maxWidth: "60px", 
                                height: "60px", 
                                fontSize: "22px", 
                                borderRadius: "8px", 
                                padding: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.65)",
                                backdropFilter: "blur(5px)",
                                WebkitBackdropFilter: "blur(5px)"
                            }}
                            onClick={() => handleKey(key)}
                        >
                            {key}
                        </button>
                    ))}

                    {/* Botão Apagar ao final da 3ª linha */}
                    {i === 2 && (
                        <button 
                            className="btn shadow-sm border border-danger text-danger d-flex align-items-center justify-content-center" 
                            style={{ 
                                flex: "1 1 0px", 
                                minWidth: "0", 
                                maxWidth: "60px", 
                                height: "60px", 
                                borderRadius: "8px", 
                                padding: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.75)",
                                backdropFilter: "blur(5px)",
                                WebkitBackdropFilter: "blur(5px)"
                            }} 
                            onClick={onDelete}
                        >
                            <i className="mdi mdi-backspace-outline font-size-22"></i>
                        </button>
                    )}
                </div>
            ))}
            
            {/* Linha Inferior: Controle */}
            <div className="d-flex justify-content-center mt-2 w-100" style={{ gap: "4px" }}>
                <button 
                    className="btn shadow-sm border-0 fw-bold text-dark w-50" 
                    style={{ 
                        height: "60px", 
                        borderRadius: "8px", 
                        fontSize: "18px", 
                        maxWidth: "250px",
                        backgroundColor: "rgba(255, 255, 255, 0.65)",
                        backdropFilter: "blur(5px)",
                        WebkitBackdropFilter: "blur(5px)"
                    }} 
                    onClick={onSpace}
                >
                    ESPAÇO
                </button>
            </div>
        </div>
    );
};

VirtualKeyboard.propTypes = {
    onKeyPress: PropTypes.func,
    onDelete: PropTypes.func,
    onSpace: PropTypes.func,
    onClear: PropTypes.func
};

export default VirtualKeyboard;
